/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BankSlug } from '../model';
// @ts-ignore
import { V1OauthBankSlugCallbackGet200Response } from '../model';
// @ts-ignore
import { V1OauthBankSlugCallbackGet207Response } from '../model';
/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Redirects frontend to banks page
         * @summary Get Bank redirection
         * @param {BankSlug} bankSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OauthBankSlugAuthorizationUrlGet: async (bankSlug: BankSlug, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankSlug' is not null or undefined
            assertParamExists('v1OauthBankSlugAuthorizationUrlGet', 'bankSlug', bankSlug)
            const localVarPath = `/v1/oauth/{bank_slug}/authorization-url`
                .replace(`{${"bank_slug"}}`, encodeURIComponent(String(bankSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept callback from frontend and validates the code, then creates a new access token. If access token already exists, it will be updated. Create accounts related to the access token and update transaction data except for NETBK and MUFG Banks. For NETBK and MUFG Banks, the accounts are not created automatically and should use post /accounts/{bank_slug} to create accounts. Updates transaction data for accounts that already exists. 
         * @summary Accept Callback from Frontend
         * @param {BankSlug} bankSlug 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OauthBankSlugCallbackGet: async (bankSlug: BankSlug, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankSlug' is not null or undefined
            assertParamExists('v1OauthBankSlugCallbackGet', 'bankSlug', bankSlug)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('v1OauthBankSlugCallbackGet', 'code', code)
            const localVarPath = `/v1/oauth/{bank_slug}/callback`
                .replace(`{${"bank_slug"}}`, encodeURIComponent(String(bankSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * Redirects frontend to banks page
         * @summary Get Bank redirection
         * @param {BankSlug} bankSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1OauthBankSlugAuthorizationUrlGet(bankSlug: BankSlug, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1OauthBankSlugAuthorizationUrlGet(bankSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accept callback from frontend and validates the code, then creates a new access token. If access token already exists, it will be updated. Create accounts related to the access token and update transaction data except for NETBK and MUFG Banks. For NETBK and MUFG Banks, the accounts are not created automatically and should use post /accounts/{bank_slug} to create accounts. Updates transaction data for accounts that already exists. 
         * @summary Accept Callback from Frontend
         * @param {BankSlug} bankSlug 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1OauthBankSlugCallbackGet(bankSlug: BankSlug, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1OauthBankSlugCallbackGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1OauthBankSlugCallbackGet(bankSlug, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * Redirects frontend to banks page
         * @summary Get Bank redirection
         * @param {AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OauthBankSlugAuthorizationUrlGet(requestParameters: AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1OauthBankSlugAuthorizationUrlGet(requestParameters.bankSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept callback from frontend and validates the code, then creates a new access token. If access token already exists, it will be updated. Create accounts related to the access token and update transaction data except for NETBK and MUFG Banks. For NETBK and MUFG Banks, the accounts are not created automatically and should use post /accounts/{bank_slug} to create accounts. Updates transaction data for accounts that already exists. 
         * @summary Accept Callback from Frontend
         * @param {AuthorizationApiV1OauthBankSlugCallbackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OauthBankSlugCallbackGet(requestParameters: AuthorizationApiV1OauthBankSlugCallbackGetRequest, options?: AxiosRequestConfig): AxiosPromise<V1OauthBankSlugCallbackGet200Response> {
            return localVarFp.v1OauthBankSlugCallbackGet(requestParameters.bankSlug, requestParameters.code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1OauthBankSlugAuthorizationUrlGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest
 */
export interface AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest {
    /**
     * 
     * @type {BankSlug}
     * @memberof AuthorizationApiV1OauthBankSlugAuthorizationUrlGet
     */
    readonly bankSlug: BankSlug
}

/**
 * Request parameters for v1OauthBankSlugCallbackGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiV1OauthBankSlugCallbackGetRequest
 */
export interface AuthorizationApiV1OauthBankSlugCallbackGetRequest {
    /**
     * 
     * @type {BankSlug}
     * @memberof AuthorizationApiV1OauthBankSlugCallbackGet
     */
    readonly bankSlug: BankSlug

    /**
     * 
     * @type {string}
     * @memberof AuthorizationApiV1OauthBankSlugCallbackGet
     */
    readonly code: string
}

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * Redirects frontend to banks page
     * @summary Get Bank redirection
     * @param {AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public v1OauthBankSlugAuthorizationUrlGet(requestParameters: AuthorizationApiV1OauthBankSlugAuthorizationUrlGetRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).v1OauthBankSlugAuthorizationUrlGet(requestParameters.bankSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept callback from frontend and validates the code, then creates a new access token. If access token already exists, it will be updated. Create accounts related to the access token and update transaction data except for NETBK and MUFG Banks. For NETBK and MUFG Banks, the accounts are not created automatically and should use post /accounts/{bank_slug} to create accounts. Updates transaction data for accounts that already exists. 
     * @summary Accept Callback from Frontend
     * @param {AuthorizationApiV1OauthBankSlugCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public v1OauthBankSlugCallbackGet(requestParameters: AuthorizationApiV1OauthBankSlugCallbackGetRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).v1OauthBankSlugCallbackGet(requestParameters.bankSlug, requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}
